import React from "react";
import Close from "../../assets/icons/Close.svg";

interface ChipProps {
  title: string;
  bgColor?: string;
  textColor?: string;
  className?: string;
  onClose?: () => void;
  withMargins?: boolean;
}

const Chip = ({
  title,
  bgColor = "bg-white",
  textColor = "text-vibrant-green",
  className,
  onClose,
  withMargins = true
}: ChipProps): JSX.Element => {
  return (
    <div
      className={`flex flex-row items-center justify-center px-3 py-[2px] ${withMargins ? "mr-[7px] my-4" : ""} rounded-2xl ${bgColor} ${className}`}
    >
      <p className={` caption p-2 ${textColor}`}>{title}</p>
      {onClose && (
        <Close
          className="h-[18px] w-[18px] ml-3 cursor-pointer"
          onClick={onClose}
        />
      )}
    </div>
  );
};

export default Chip;
